export function getFileNameFromContentDisposition(contentDisposition: string): string | null {
    // Expressão regular para extrair o nome do arquivo
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(contentDisposition);
  
    if (matches != null && matches[1]) {
      // Remove aspas do nome do arquivo, se houver
      return matches[1].replace(/['"]/g, '');
    }
  
    return null; // Retorna null se não encontrar o nome do arquivo
  }